import { useLocation, Navigate, Outlet } from "react-router-dom"

import { useUserPermissions } from "api/hooks"
import useAppState from "context/hooks/useAppState"
import APP_STATE from "constants/appState.js"

const RequireAuth = ({}) => {
  const location = useLocation()
  const pathname = location.pathname

  const { appState } = useAppState()
  const { data: permissions, isLoading: isPermissionsLoading } = useUserPermissions()

  if (isPermissionsLoading === false && !permissions)
    return (
      <Navigate
        to="/login"
        state={{ from: pathname }}
        replace={true}
      />
    )

  if (appState === APP_STATE.authenticated) {
    return <Outlet />
  }

  return (
    <Navigate
      to="/login"
      state={{ from: pathname }}
      replace={true}
    />
  )
}

export default RequireAuth
